export default "__VITE_ASSET__8b761dc2__"